// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__WSH-L","content":"LayoutSettings_content__1HFAi"};